/**
 * Test IDs for QA automation.
 */
export const testIds = {
  relationshipFormSave: "relationship-form-save",
} as const;
